import React, { useState, forwardRef, Ref } from "react";
import "./textarea.less";
type RowsType = number | undefined;
type AutoSizeType = {
   minRows: number;
   maxRows?: RowsType;
};
interface Props {
   className?: string;
   id?: string;
   name?: string;
   defaultValue?: string;
   value?: string;
   rows?: number;
   autoSize?: AutoSizeType;
   style?: React.CSSProperties;
   disabled?: boolean;
   placeholder?: string;
   onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
   onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
   maxLength?: number;
}

export const TextArea = forwardRef(
   (
      {
         className,
         id,
         defaultValue,
         value,
         rows,
         autoSize,
         style,
         disabled = false,
         placeholder = "",
         name,
         onChange,
         onKeyDown,
         maxLength,
      }: Props,
      ref: Ref<HTMLTextAreaElement>,
   ) => {
      const [textValue, setTextValue] = useState<string>(defaultValue ?? "");

      const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
         if (!value) {
            setTextValue(e.target.value);
         }
         if (typeof onChange === "function") {
            onChange(e);
         }
      };
      const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>): void => {
         if (typeof onKeyDown === "function") {
            onKeyDown(e);
         }
      };
      const setTextAreaRows = (rows?: RowsType, minRows?: RowsType): number => {
         if (rows !== undefined) {
            return rows;
         } else if (minRows !== undefined) {
            return minRows;
         } else {
            return 3;
         }
      };
      return (
         <textarea
            className={`bp2textarea ${className ? className : ""}`}
            id={id}
            value={value ?? textValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            rows={setTextAreaRows(rows, autoSize?.minRows)}
            style={style}
            disabled={disabled}
            placeholder={placeholder}
            ref={ref}
            name={name}
            maxLength={maxLength}
         />
      );
   },
);
export default TextArea;
